module.exports = {
    publicUrl: 'https://tramitar.driza.online',
    env: 'production'
};
